import React from 'react';
import { HelpCircleIcon, MessageCircleIcon, BookOpenIcon, PhoneIcon } from 'lucide-react';
const Support = () => {
  const faqs = [{
    question: 'How do I publish my book?',
    answer: "To publish your book, go to your dashboard and click on 'Add New Book'. Follow the step-by-step guide to upload your manuscript and cover."
  }, {
    question: 'How are royalties calculated?',
    answer: 'Royalties are calculated based on the list price of your book. For eBooks, you earn 70% of the list price, and for print books, you earn 60%.'
  }];
  return <div className="min-h-screen bg-gray-50 py-8" data-id="element-15002" data-mp="bxxisgj5gqh7">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15003" data-mp="c0bbiiqcxqll">
        <div className="text-center mb-8" data-id="element-15004" data-mp="gy33fcr05cps">
          <h1 className="text-3xl font-bold text-gray-900" data-id="element-15005" data-mp="guxim9peowzv">Support Center</h1>
          <p className="mt-2 text-lg text-gray-600" data-id="element-15006" data-mp="1nd405knupyxf">
            How can we help you today?
          </p>
        </div>
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 mb-12" data-id="element-15007" data-mp="1se9ufmx5tu92">
          <div className="bg-white rounded-lg shadow-md p-6" data-id="element-15008" data-mp="21wcc336hauav">
            <MessageCircleIcon className="h-8 w-8 text-indigo-600 mb-4" data-id="element-15009" data-mp="1wxrbh2nbe8lw" />
            <h2 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-15010" data-mp="1ryo3pafy9oa8">
              Chat Support
            </h2>
            <p className="text-gray-600 mb-4" data-id="element-15011" data-mp="1n0cvt597tnun">
              Get instant help from our support team
            </p>
            <button className="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 w-full" data-id="element-15012" data-mp="1izb3z9hmoe2p">
              Start Chat
            </button>
          </div>
          <div className="bg-white rounded-lg shadow-md p-6" data-id="element-15013" data-mp="1986q6d3ouz9g">
            <BookOpenIcon className="h-8 w-8 text-indigo-600 mb-4" data-id="element-15014" data-mp="198pwsxnw2186" />
            <h2 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-15015" data-mp="14aemymxlfqpy">
              Knowledge Base
            </h2>
            <p className="text-gray-600 mb-4" data-id="element-15016" data-mp="z9qz2a4nvpzy">
              Browse our help articles and tutorials
            </p>
            <button className="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 w-full" data-id="element-15017" data-mp="varx8ye889cq">
              View Articles
            </button>
          </div>
          <div className="bg-white rounded-lg shadow-md p-6" data-id="element-15018" data-mp="pnfz11xy3efz">
            <PhoneIcon className="h-8 w-8 text-indigo-600 mb-4" data-id="element-15019" data-mp="bn57rxsq3xua" />
            <h2 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-15020" data-mp="boyfzhiziq4e">
              Contact Us
            </h2>
            <p className="text-gray-600 mb-4" data-id="element-15021" data-mp="gnt6z6r3vkzl">
              Get in touch with our support team
            </p>
            <button className="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 w-full" data-id="element-15022" data-mp="18d4ncc7ajwmd">
              Contact Support
            </button>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-md p-6" data-id="element-15023" data-mp="ujwwwnuy5769">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-15024" data-mp="zjj9cv2yaje0">
            Frequently Asked Questions
          </h2>
          <div className="space-y-6" data-id="element-15025" data-mp="1n93wlq6502t3">
            {faqs.map((faq, index) => <div key={index} data-id="element-15026" data-mp="1s1wxg2yhiqzw" data-mpi={index}>
                <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-15027" data-mp="1s2yd6kqg41ny">
                  <HelpCircleIcon className="h-5 w-5 text-indigo-600 inline mr-2" data-id="element-15028" data-mp="21edz79lboso7" />
                  {faq.question}
                </h3>
                <p className="text-gray-600 ml-7" data-id="element-15029" data-mp="2b5qp3vnk98rl">{faq.answer}</p>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
};
export default Support;